import BaseService from '../base.service'
export class AdminAIGroupMenuService extends BaseService {
  /**
   * The constructor for the ArtistService.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor (parameters = {}) {
    super('api/ai_group_menu', parameters)
  }
}